import ProjectType from '@core/project-type'

// With API_DEV_PROXY set (next dev, the E2E build) the browser calls /api and
// /data on its own origin and proxy.ts forwards them. Mobile and production
// builds keep the real URLs.
export const withDevProxy = (project: ProjectType): ProjectType => {
  if (!process.env.API_DEV_PROXY) {
    return project
  }
  // Same-origin but absolute: axios joins a relative url onto its baseURL
  const origin = typeof window === 'undefined' ? '' : window.location.origin
  return {
    ...project,
    api: `${origin}/api/`,
    apiBaseUrl: `${origin}/`,
    devProxy: { api: project.api, apiBaseUrl: project.apiBaseUrl },
  }
}
